export enum MENU_ROUTES {
  HOME = 'home',
  SUBTITLES = 'subtitles',
  STYLES = 'styles',
  STYLES_COLOR = 'text_color',
  STYLES_BACKGROUND_COLOR = 'background_color',
  STYLES_BORDER = 'border_style',
  STYLES_BACKGROUND_OPACITY = 'background_opacity',
  STYLES_FONT_SIZE = 'font_size',
}
